<template>
    <v-navigation-drawer
        :mini-variant.sync="mini"
        permanent
        expand-on-hover
        hide-overlay
        app
        clipped
        mini-variant-width="75"
    >
        <div class="head py-3">
            <v-list-item>
                <v-list-item-avatar color="primary">
                    <v-icon dark>mdi-package</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title class="text-h6 text-capitalize font-weight-bold">
                        {{ project ? project : $t('layout.unassigned_project') }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="button grey--text text--darken-4">
                        {{ user.name ? user.name : $t('layout.username') }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </div>

        <div class="content slide">
            <v-list dense>
                <v-list-item-group color="primary">
                    <v-list-item @click="$router.push({ name: 'home' }).catch(() => {})" link>
                        <v-list-item-action>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('home.title') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>

                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-action :class="{ 'ml-n4': !mini }">
                                <v-icon>mdi-remote</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t('layout.control') }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-list-item :to="{ name: 'control' }" class="ml-n1" link>
                        <v-list-item-title>
                            <v-icon class="mr-3">mdi-lightbulb-on-outline</v-icon>
                            {{ $t('control_center.title') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="ml-n1" :to="{ name: 'ControlLayouts' }">
                        <v-list-item-action>
                            <v-icon>mdi-home-modern</v-icon>
                        </v-list-item-action>
                        <v-list-item-content class="ml-n4">
                            <v-list-item-title>
                                {{ $t('layout_control.title') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-item-group>
                    <v-list-item :to="{ name: 'schedules' }" link>
                        <v-list-item-action>
                            <v-icon>mdi-clock-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('schedules.title') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>

                <v-list-item-group>
                    <v-list-item>
                        <v-list-item-action>
                            <v-icon>mdi-arrow-down-bold-box-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('downtime_panel.title') }}
                            </v-list-item-title>
                            <v-list-item-subtitle style="font-size: 10px">
                                {{ $t('common.in_maintenance') }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>

                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-action :class="{ 'ml-n4': !mini }">
                                <v-icon>mdi-battery-charging-80</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t('layout.energy') }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-list-item :to="{ name: 'MeterMenu' }" class="ml-n7" link>
                        <v-list-item-title>
                            <v-icon class="mr-3">mdi-speedometer</v-icon>
                            {{ $t('meters.title') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="ml-n7" :to="{ name: 'GroupMenu' }">
                        <v-list-item-title>
                            <v-icon class="mr-3">mdi-google-circles-communities</v-icon>
                            {{ $t('groups.title') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="ml-n7" :to="{ name: 'LayoutMeter' }">
                        <v-list-item-action>
                            <v-icon>mdi-home-modern</v-icon>
                        </v-list-item-action>
                        <v-list-item-content class="ml-n4">
                            <v-list-item-title>
                                {{ $t('metering_layout.title') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="ml-n7" :to="{ name: 'LayoutOneLineDiagram' }">
                        <v-list-item-action>
                            <v-icon>mdi-lan</v-icon>
                        </v-list-item-action>
                        <v-list-item-content class="ml-n4">
                            <v-list-item-title>
                                {{ $t('one_line_diagram.title') }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-action :class="{ 'ml-n4': !mini }">
                                <v-icon>mdi-grid</v-icon>
                            </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('pulse_volt.acronym') }}
                            </v-list-item-title>
                        </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-list-item class="ml-n7" :to="{ name: 'GEM' }" link>
                        <v-list-item-title>
                            <v-icon class="mr-3">mdi-battery-charging</v-icon>
                            {{ $t('pulse_volt.title') }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-group>

                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-action :class="{ 'ml-n4': !mini }">
                                <v-icon>mdi-view-dashboard</v-icon>
                            </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ $t('layout.admin_panel') }}
                            </v-list-item-title>
                        </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-list-item class="ml-n1" :to="{ name: 'Logger' }" link>
                        <v-list-item-title>
                            <v-icon class="mr-3">mdi-message-text-outline</v-icon>
                            {{ $t('logs.title') }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item class="ml-n1" :to="{ name: 'ProjectInfo' }" link>
                        <v-list-item-title>
                            <v-icon class="mr-3">mdi-information-outline</v-icon>
                            {{ $t('project_info.title') }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'
export default {
    name: 'Drawer',
    data: () => ({
        mini: true,
    }),
    computed: {
        ...mapState({
            user: (state) => state.user.data,
            project: (state) => state.project.name,
        }),
    },
    methods: {
        ...mapMutations({
            setDrawer: 'app/SET_DRAWER_VISIBLE',
        }),
        ...mapGetters({
            logout: 'authentication/logout',
        }),
        ...mapActions({
            fetchGateways: "gateways/fetchGateways",
        }),
    },
    async mounted() {
        if(!this.project) return
        await this.fetchGateways()
    },
}
</script>

<style scoped>
.head {
  border-bottom: 1px solid rgb(190 190 190 / 58%);
}
.slide {
  overflow: hidden;
  overflow-y: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.content {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  margin-bottom: 48px;
}
.bottom-controllers {
  color: rgba(0, 0, 0, 0.655);
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  padding: 6px 12px;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  border-top: 1px solid rgb(190 190 190 / 58%);
}
</style>
